import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { FinancialConnectionGocardlessAccessScopes } from './financial-connection.provider-fields.gocardless.access-scope.enum';

export const FinancialConnectionProviderFieldsGocardlessAgreementSchema = z
    .object({
        id: z.string(),
        scopes: z.array(EnumSchema(FinancialConnectionGocardlessAccessScopes)),
        maxHistoricalDays: z.number(),
        accessValidForDays: z.number(),
    })
    .strict();

export class FinancialConnectionProviderFieldsGocardlessAgreement extends FromSchema(
    FinancialConnectionProviderFieldsGocardlessAgreementSchema,
) {
    id: string;
    scopes: FinancialConnectionGocardlessAccessScopes[];
    maxHistoricalDays: number;
    accessValidForDays: number;
}
